import { FC, useEffect } from "react";
import { Outlet, useLocation } from "react-router-dom";
import { Box, Paper, Toolbar } from "@mui/material";
import { AlertProvider } from "../../context/AlertContext";
import { DynamicSidebarProvider } from "../../context/DynamicSidebarContext";
import TopBar from "./TopBar";

import useMenuStore from "../../stores/MenuStore";
import AlertsContainer from "../Alerts/AlertsContainer";
import DynamicSidebar from "./DynamicSidebar";

interface LayoutProps {
  IsAdminMode?: boolean;
}

const Layout: FC<LayoutProps> = ({ IsAdminMode = false }) => {
  const { isDrawerOpen, setIsAdminMode } = useMenuStore();
  const location = useLocation();

  useEffect(() => {
    setIsAdminMode(IsAdminMode);
  }, [location, setIsAdminMode]);

  return (
    <AlertProvider>
      <DynamicSidebarProvider>
        <Box sx={{ display: "flex" }}>
          <TopBar />
          <DynamicSidebar />
          <main className={`${isDrawerOpen ? "open" : ""}`}>
            <Toolbar />
            <Paper className="body">
              <Outlet />
            </Paper>
          </main>
        </Box>
        <AlertsContainer />
      </DynamicSidebarProvider>
    </AlertProvider>
  );
};

export default Layout;
